import {useContext} from "react";
import {RestorationContainer, HeaderCentered} from "./restoration.styles";

import rack1ru from '../../assets/img/1-ru.jpg';
import rack2ru from '../../assets/img/2-ru.jpg';
import rack3ru from '../../assets/img/3-ru.jpg';
import rack4ru from '../../assets/img/4-ru.jpg';
import rack1ro from '../../assets/img/1-ro.jpg';
import rack2ro from '../../assets/img/2-ro.jpg';
import rack3ro from '../../assets/img/3-ro.jpg';
import rack4ro from '../../assets/img/4-ro.jpg';
import rack5ro from '../../assets/img/5-ro.jpg';
import rack6ro from '../../assets/img/6-ro.jpg';
import rack7ro from '../../assets/img/7-ro.jpg';
import rack8ro from '../../assets/img/8-ro.jpg';
import rack6ru from '../../assets/img/6-ru.jpg';
import rack7ru from '../../assets/img/7-ru.jpg';
import rack8ru from '../../assets/img/8-ru.jpg';
import rack9ro from '../../assets/img/9-ro.jpg';
import rack9ru from '../../assets/img/9-ru.jpg';
import rack10ro from '../../assets/img/10-ro.jpg';
import rack10ru from '../../assets/img/10-ru.jpg';
import rack11ro from '../../assets/img/11-ro.jpg';
import rack11ru from '../../assets/img/11-ru.jpg';
import rack12ro from '../../assets/img/12-ro.jpg';
import rack12ru from '../../assets/img/12-ru.jpg';

import {LanguageContext} from "../../contexts/language.context";
import "./styles.scss";

const Restoration = ({props}) => {
    const {romanianLanguage} = useContext(LanguageContext);

    const images = romanianLanguage
        ? [rack6ro, rack7ro, rack8ro, rack9ro, rack10ro, rack11ro, rack12ro]
        : [rack6ru, rack7ru, rack8ru, rack9ru, rack10ru, rack11ru, rack12ru];

    return (
        <RestorationContainer id="services">
            <HeaderCentered>
                <h2>{props[1]}</h2>
            </HeaderCentered>
            <div className="restoration-items">
                {images.map((image, index) => (
                    <div className="restoration_item" key={index}>
                        <img src={image} alt={`Rack ${index + 1}`}/>
                    </div>
                ))}
            </div>
        </RestorationContainer>
    );
};

export default Restoration;